// extracted by mini-css-extract-plugin
export default {"home":"Home_home__CMw1J","about_me":"Home_about_me__WznVo","social":"Home_social__RuNos"};